import React, { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import ImageChecker from "../../Generic/ImageChecker";

import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  InputNumber,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import "./styles.scss";

import moment from "moment";
import {
  getData,
  editItem,
  addItem,
  deleteItem,
} from "../../../Redux/actions/crudActions";
import { errorParser } from "../../../utils/helpers";
import {
  getMenuItems,
  setSale,
} from "../../../Redux/actions/dailysalesActions";
import { setWastedMenu } from "../../../Redux/actions/wastedmenuActions";

import { getProduct } from "../../../Redux/actions/productActions";
import { setProductInventory } from "../../../Redux/actions/inventoryActions";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({ onModalClose }) => {
  const dispatch = useDispatch();
  const { menuitems } = useSelector(
    (state) => ({
      menuitems: state.dailysales.menuitems,
    }),
    shallowEqual
  );

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [loading, setLoading] = useState(false);
  const [categorized, setCategorized] = useState([]);
  const [itemcount, setItemcount] = useState([]);
  const [createDate, setCreatedDate] = useState(moment());

  useEffect(() => {}, []);

  useEffect(() => {
    if (isModalVisible) {
      dispatch(getMenuItems());
    }
  }, [isModalVisible]);

  useEffect(() => {
    if (menuitems) {
      docategorized();
      console.log(menuitems);
    }
  }, [menuitems]);

  const docategorized = () => {
    var categories = [];

    menuitems.map((it) => {
      if (!categories.includes(it.category_name)) {
        categories.push(it.category_name);
      }
    });
    var newcats = [];
    categories.map((ct) => {
      var catprods = [];
      menuitems.map((it) => {
        if (ct == it.category_name) {
          catprods.push(it);
        }
      });
      var sortedprods = catprods.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      );
      var newcatp = {
        category: ct,
        products: sortedprods,
      };
      newcats.push(newcatp);
    });

    console.log(newcats);
    setCategorized(newcats);
  };

  const chagnequantity = (prod, count) => {
    var newItemCount = itemcount;
    newItemCount[prod] = count;
    setItemcount(newItemCount);
    console.log(newItemCount);
  };

  const renderTable = (currentgroup) => {
    const columns = [
      {
        title: "Image",

        render: (text, record, index) => {
          return (
            <ImageChecker
              url={`${process.env.REACT_APP_AWS_S3}${record.id}.png`}
              success={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}${record.id}.png`}
                  alt="image"
                  className={"prodimage"}
                />
              }
              fail={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}logo192.png`}
                  alt="image"
                  className={"prodimage"}
                />
              }
            />
          );
        },
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        sorter: {
          compare: (a, b) => a.name - b.name,
        },

        search: "name",
      },
      {
        title: "count",

        render: (text, record, index) => {
          return (
            <InputNumber
              min={0}
              width={"100%"}
              defaultValue={0}
              step={1}
              onChange={(e) => {
                chagnequantity(record.id, e);
              }}
            />
          );
        },
      },
    ];

    return (
      <Collapse defaultActiveKey={["1"]} className={"category_containter"}>
        <Panel header={currentgroup.category} key="1">
          <Table
            columns={columns}
            dataSource={currentgroup.products}
            pagination={false}
            showHeader={false}
          />
        </Panel>
      </Collapse>
    );
  };

  const summarizeSale = (thisitemcount) => {
    var ingredient_ids = [];
    var ingredients_base = [];
    var ingredients_count = [];

    var products_sold = [];

    Object.entries(thisitemcount).map((item) => {
      var item_id = item[0];
      var item_quantity = item[1];

      if (item_quantity > 0) {
        var current_prod = menuitems.filter((x) => x.key == item_id);
        if (current_prod[0]) {
          current_prod = current_prod[0];

          var recorded_product = {
            ...current_prod,
            quantity_wasted: item_quantity,
          };

          products_sold.push(recorded_product);
        }
        if (current_prod.ingredients) {
          current_prod.ingredients.map((ingrd) => {
            var new_ingrd = {
              ...ingrd,
              quantity: parseFloat(ingrd.quantity) * parseFloat(item_quantity),
            };
            ingredients_count.push(new_ingrd);

            if (!ingredient_ids.includes(new_ingrd.product)) {
              var ind_base = {
                product: new_ingrd.product,
                product_name: new_ingrd.product_name,
              };
              ingredient_ids.push(new_ingrd.product);
              ingredients_base.push(ind_base);
            }
          });
        }
      }
    });

    // console.log(ingredients_base)
    // console.log(ingredients_count)

    var ingredient_final = [];

    ingredients_base.map((ingd) => {
      var all_has = ingredients_count.filter((i) => i.product == ingd.product);

      var product_total = 0;
      all_has.map((same_prod) => {
        product_total = product_total + parseFloat(same_prod.quantity);
      });

      var new_count = {
        ...ingd,
        quantity: product_total,
      };

      ingredient_final.push(new_count);
    });

    if (products_sold.length > 0) {
      createSale(products_sold, ingredient_final);
    } else {
      message.warning("select item");
    }
  };

  const createSale = async (products_sold, ingredient_final) => {
    console.log(products_sold);
    console.log(ingredient_final);

    if (!loading) {
      setLoading(true);
      message.info("recording sales");
      var save_ingredients = [];
      await Promise.all(
        ingredient_final.map(async (indx, i) => {
          var product3 = await dispatch(
            setProductInventory(
              indx.product,
              indx.product_name,
              indx.quantity,
              "subtract",
              "wasted"
            )
          );

          var prodsource = await dispatch(getProduct(indx.product));
          if (prodsource) {
            var newingredient = {
              ...indx,
              category: prodsource.category ? prodsource.category : "",
              category_name: prodsource.category_name
                ? prodsource.category_name
                : "",
              cost_peso: prodsource.cost_peso ? prodsource.cost_peso : 0,
              cost_rmb: prodsource.cost_rmb ? prodsource.cost_rmb : 0,

              second_unit: prodsource.second_unit ? prodsource.second_unit : 0,
              unit: prodsource.unit ? prodsource.unit : "",
            };

            save_ingredients.push(newingredient);
          } else {
            message.error(indx.product_name + " not found");
          }
          message.info(
            `(${i + 1}/${ingredient_final.length})  ${
              indx.product_name
            } updated`
          );
        })
      );

      var newsold = await dispatch(
        setWastedMenu(products_sold, save_ingredients, createDate)
      );

      setLoading(false);
      closeModal("reset");
    }
  };
  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current > moment().endOf("day");
  };

  const footer = () => {
    return (
      <div className="addsalesfooter">
        <div>
          <DatePicker
            defaultValue={createDate}
            value={createDate}
            disabledDate={disabledDate}
            onChange={(e) => {
              setCreatedDate(e);
            }}
          />
        </div>
        <div>
          <Popconfirm
            title="Are you sure this list is correct?"
            onConfirm={() => {
              summarizeSale(itemcount);
            }}
            okText="Yes"
            cancelText="No"
          >
            <Button type="primary" loading={loading}>
              add
            </Button>
          </Popconfirm>
        </div>
      </div>
    );
  };

  const closeModal = (action) => {
    if (!loading) {
      setItemcount([]);

      setIsModalVisible(false);
      onModalClose(action);
    }
  };

  return (
    <>
      <div className={"addeditbutton"}>
        <Button
          type="primary"
          shape="round"
          icon={<PlusOutlined />}
          onClick={() => {
            setIsModalVisible(true);
            setLoading(false);
          }}
        >{`Add Wasted Orders`}</Button>
      </div>

      {isModalVisible ? (
        <Modal
          title={`Add Wasted Orders`}
          visible={isModalVisible}
          footer={footer()}
          onCancel={() => {
            closeModal();
          }}
        >
          <div className="dailysalesmodal-content">
            {categorized.map((cat) => {
              return renderTable(cat);
            })}
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default Index;
